import { InputDiagramsType } from 'helper/converter/measurement-diagrams-converter/measurement-diagrams-converter';
import {
	MeasurementDiagramTypeType,
	OverviewType,
	PayloadType,
	SaveMeasurmenetType,
	TrackingHistoryItemType,
} from './dashboard';
import {
	DASHBOARD_LOADING,
	FLUSH_PROGRAM,
	RECEIVED_DASHBOARD_MEASUREMENT,
	RECEIVED_DASHBOARD_MEASUREMENT_DIAGRAM,
	RECEIVED_OVERVIEW,
	RECEIVED_PROGRAM,
	REQUEST_DASHBOARD,
	REQUEST_DASHBOARD_MEASUREMENT,
	REQUEST_DASHBOARD_MEASUREMENT_DIAGRAM,
	REQUEST_SAVE_DASHBOARD_MEASUREMENT,
	REQUEST_SAVE_DASHBOARD_MEASUREMENT_SUCCESS,
} from './dashboard.actionTypes';

export const actionCreators = {
	doFlushDashboardProgram: () => ({
		type: FLUSH_PROGRAM,
	}),
	doRequestDashboard: () => ({
		type: REQUEST_DASHBOARD,
	}),
	doDashboardLoading: (loading: boolean) => ({
		type: DASHBOARD_LOADING,
		loading,
	}),
	doReceivedProgram: (payload: PayloadType) => ({
		type: RECEIVED_PROGRAM,
		payload,
	}),
	doReceivedOverview: (payload: OverviewType) => ({
		type: RECEIVED_OVERVIEW,
		payload,
	}),
	doRequestMeasurement: (payload: PayloadType) => ({
		type: REQUEST_DASHBOARD_MEASUREMENT,
		payload,
	}),
	doReceivedMeasurement: (payload: TrackingHistoryItemType) => ({
		type: RECEIVED_DASHBOARD_MEASUREMENT,
		payload,
	}),
	doSaveMeasurement: (id: string | undefined, measurement: SaveMeasurmenetType) => ({
		type: REQUEST_SAVE_DASHBOARD_MEASUREMENT,
		measurement,
		id,
	}),
	doSaveMeasurementSuccess: (measurement: SaveMeasurmenetType) => ({
		type: REQUEST_SAVE_DASHBOARD_MEASUREMENT_SUCCESS,
		measurement,
	}),
	doRequestMeasurementDiagram: (selectedType: MeasurementDiagramTypeType) => {
		return {
			type: REQUEST_DASHBOARD_MEASUREMENT_DIAGRAM,
			selectedType,
		};
	},
	doReceivedMeasurementDiagram: (payload: InputDiagramsType) => ({
		type: RECEIVED_DASHBOARD_MEASUREMENT_DIAGRAM,
		payload,
	}),
};

export type DashboardActionType =
	| ReturnType<typeof actionCreators.doFlushDashboardProgram>
	| ReturnType<typeof actionCreators.doRequestDashboard>
	| ReturnType<typeof actionCreators.doDashboardLoading>
	| ReturnType<typeof actionCreators.doReceivedProgram>
	| ReturnType<typeof actionCreators.doReceivedOverview>
	| ReturnType<typeof actionCreators.doRequestMeasurement>
	| ReturnType<typeof actionCreators.doReceivedMeasurement>
	| ReturnType<typeof actionCreators.doSaveMeasurement>
	| ReturnType<typeof actionCreators.doSaveMeasurementSuccess>
	| ReturnType<typeof actionCreators.doRequestMeasurementDiagram>
	| ReturnType<typeof actionCreators.doReceivedMeasurementDiagram>;
